import Grid from '@mui/joy/Grid'
import Typography from '@mui/joy/Typography'
import { Card } from '@mui/joy'
import React from 'react'
import { useGetMyStoresQuery } from '../services/stores'
import StoreLoading from './StoreLoading'
import StoreLayout from './StoreLayout'

function MyStores() {
  const { data: myStoresResp, isLoading: myStoresLoading } =
    useGetMyStoresQuery()

  if (myStoresLoading) {
    return (
      <>
        <Grid sx={{ pb: 2 }}>
          <StoreLoading />
        </Grid>
        <Grid sx={{ pb: 2 }}>
          <StoreLoading />
        </Grid>
        <Grid sx={{ pb: 2 }}>
          <StoreLoading />
        </Grid>
      </>
    )
  }

  return (
    <Grid sx={{ minHeight: '100vh' }}>
      {myStoresResp?.length === 0 && (
        <Card size="lg">
          <Typography>Még egy üzlethez sem csatlakoztál</Typography>
        </Card>
      )}
      {myStoresResp?.map((value) => (
        <Grid key={value.id} sx={{ pb: 2 }}>
          <StoreLayout store={value} clickable={true} />
        </Grid>
      ))}
    </Grid>
  )
}

export default MyStores
